<ngx-loading-bar color="#0025f9"></ngx-loading-bar>
<div class="center-screen">
    <div>
        <img src="/assets/images/kargoru-logo.svg" alt="" />
        <p>Para garantizate una mejor experienca, debes iniciar sesion desde un dispositivo de escritorio (Computador).</p>
    </div>
</div>